const Getters = {
  // ファイルアップロード
  getUploadUrlFromState: (state) => {
    return state.uploadUrl
  },
  getCsvUploadTotalFromState: (state) => {
    return state.csvUploadTotal
  },
  getCsvUploadErrorListFromState: (state) => {
    return state.csvUploadErrorList
  },
  getCsvUploadHistoryListFromState: (state) => {
    return state.csvUploadHistoryList
  }
}

export default Getters
